module.exports = __webpack_public_path__ + "img/zhxy_image_8.287a3810.png";